
<script>
/* eslint-disable no-console */
import NewForm from "./New";
export default {
  mixins: [NewForm],
  data() {
    return {};
  },
  methods: {
    load() {
      this.$http.get(`/warehouses/${this.$route.query.id}`).then((res) => {
        this.warehouse = res.data;
        this.warehouse.mappings = this.warehouse.mappings.map((p, index) => ({
          ...p,
          seq: new Date().getTime() + index,
        }));
        this.warehouse.dailySettings = this.warehouse.dailySettings.map(
          (p, index) => ({
            ...p,
            seq: new Date().getTime() + index,
          })
        );
        this.warehouse.productSettings = this.warehouse.productSettings.map(
          (p, index) => ({
            ...p,
            seq: new Date().getTime() + index,
          })
        );
      });
    },
    del() {
      this.$http.delete(`/warehouses/${this.$route.query.id}`).then(() => {
        this.$router.go(-1);
      });
    },
    save() {
      this.$http
        .put(`/warehouses/${this.$route.query.id}`, this.warehouse)
        .then(() => {
          this.$router.go(-1);
        })
        .catch((err) => {
          this.$showError(err);
        });
    },
  },
  mounted() {
    this.load();
  },
};
</script>
